<template>
  <div id="app">
    <Navigation v-if="$router.currentRoute.path !== '/login'" />
    <router-view />
    <RadishMenu v-if="$router.currentRoute.path !== '/login' && userIsAdmin" />
    <FlashMessage position="right top"/>
  </div>
</template>

<script>
import Navigation from './components/navigation'
import RadishMenu from './components/radishMenu'

export default {
  components: {Navigation, RadishMenu},
  mounted() {
    const access = JSON.parse(localStorage.getItem('accessToken'))
    if(access) this.$store.commit('setAccessToken', access.accessToken)
  },
  computed: {
    userIsAdmin() {
      return this.$store.getters.parsedUsertoken.permission_level === 10
    }
  }
}
</script>

<style lang="sass">
@import './sass/all'
</style>
